import { gql } from '@apollo/client';

/**
 * Simplified classroom query for dropdown selectors
 * Only returns id and name for minimal data transfer
 */
export const GET_CLASSROOMS_SIMPLE = gql`
  query SkWeb_Classrooms_Simple(
    $schoolId: ID
    $page: Int
    $pageSize: Int
    $sortBy: String
    $order: String
    $name: String
    $teacherId: ID
  ) {
    classroomList(
      schoolId: $schoolId
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      order: $order
      name: $name
      teacherId: $teacherId
    ) {
      data {
        id
        name
      }
      totalCount
    }
  }
`;
